import React, { useEffect } from 'react';
import apiService from '../../../services/api.service';
import { useHistory } from 'react-router';
import { useState } from 'react';
import '../../../util/extensions';
import XYChartTrends from './XYChartTrends';
import ComparePeriodLineChart from './ComparePeriodLineChart';

function PercentOfShipmentDelay(props) {
  const { FilterComponentData, baseQueryString, ShowTrendLine, ShowAvgLine } = props;
  const [trendsOverTimeReportData, setTrendsOverTimeReportData] = useState([]);
  const [mainAndCompareTrendData, setMainAndCompareTrendData] = useState();
  const [subTitle, setSubTitle] = useState('');
  const [compareChartSubTitle, setCompareChartSubTitle] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    let isCancelled = false;
    const LoadTrendReport = async (filterData) => {
      try {
        let result = await apiService.getPercentOfShipmentDelayTrendsReport(
          filterData.accountId,
          filterData.dateBasedOn,
          filterData.start,
          filterData.end,
          filterData.suppliers,
          filterData.groupBy,
          filterData.showSuppliersIndividually,
          filterData.originId,
          filterData.destinationId,
          filterData.carrierContractNumber
        );

        let avgPercent = await apiService.getAvgPercentOfShipmentDelay(
          filterData.accountId,
          filterData.dateBasedOn,
          filterData.start,
          filterData.end,
          null,
          filterData.originId,
          filterData.destinationId,
          filterData.carrierContractNumber
        );

        if (!isCancelled) {
          if (avgPercent.data) {
            setSubTitle(`(Average ${avgPercent.data.toLocaleString()}%)`);
          }

          setTrendsOverTimeReportData(result.data);
          setIsLoading(false);
        }
      } catch (err) {
        setIsLoading(false);
        console.log('error: ', err);
        if (err.response && err.response.status === 401) history.push('/login');
      }
    };

    const LoadCompareTrendReports = async (filterData) => {
      try {
        let mainReport = await apiService.getPercentOfShipmentDelayTrendsReport(
          filterData.accountId,
          filterData.dateBasedOn,
          filterData.start,
          filterData.end,
          filterData.suppliers,
          filterData.groupBy,
          filterData.showSuppliersIndividually,
          filterData.originId,
          filterData.destinationId,
          filterData.carrierContractNumber
        );

        let compareReport = await apiService.getPercentOfShipmentDelayTrendsReport(
          filterData.accountId,
          filterData.dateBasedOn,
          filterData.comparePeriodFilter.start,
          filterData.comparePeriodFilter.end,
          filterData.suppliers,
          filterData.groupBy,
          filterData.showSuppliersIndividually,
          filterData.originId,
          filterData.destinationId,
          filterData.carrierContractNumber
        );

        let mainAvgPercentResult = await apiService.getAvgPercentOfShipmentDelay(
          filterData.accountId,
          filterData.dateBasedOn,
          filterData.start,
          filterData.end,
          filterData.suppliers,
          filterData.originId,
          filterData.destinationId,
          filterData.carrierContractNumber
        );

        let compareAvgPercentResult = await apiService.getAvgPercentOfShipmentDelay(
          filterData.accountId,
          filterData.dateBasedOn,
          filterData.comparePeriodFilter.start,
          filterData.comparePeriodFilter.end,
          filterData.suppliers,
          filterData.originId,
          filterData.destinationId,
          filterData.carrierContractNumber
        );

        if (!isCancelled) {
          let mainAvgPercent = mainAvgPercentResult.data,
            compareAvgPercent = compareAvgPercentResult.data,
            valueChange,
            valueChangePercentage,
            valueChangeStatus;

          if (mainReport.data && mainReport.data.trendDatas && mainReport.data.trendDatas.length > 0 && compareAvgPercent) {
            valueChange = mainAvgPercent - compareAvgPercent;
            valueChangePercentage = (valueChange / compareAvgPercent) * 100.0;
            valueChangeStatus = 'normal';

            if (valueChange < 0) {
              valueChangeStatus = 'gain';
              valueChange = `${valueChange.toLocaleString()}`;
              valueChangePercentage = valueChangePercentage.toLocaleString();
            } else if (valueChange > 0) {
              valueChangeStatus = 'lose';
              valueChange = `+${valueChange.toLocaleString()}`;
              valueChangePercentage = `+${valueChangePercentage.toLocaleString()}`;
            }

            setCompareChartSubTitle({
              label: 'Average',
              valueText: `${mainAvgPercent.toLocaleString()}`,
              valueChange: valueChange,
              valueChangePercentage: valueChangePercentage,
              valueChangeStatus: valueChangeStatus,
            });
          } else {
            setCompareChartSubTitle({});
          }

          setIsLoading(false);
          setMainAndCompareTrendData({ main: mainReport.data, compare: compareReport.data });
        }
      } catch (err) {
        setIsLoading(false);
        console.log('error: ', err);
        if (err.response && err.response.status === 401) history.push('/login');
      }
    };

    setSubTitle('');

    if (FilterComponentData.accountId && (FilterComponentData.showAllSuppliers === true || FilterComponentData.suppliers.length > 0)) {
      setIsLoading(true);
      if (FilterComponentData.comparePeriodFilter.enabledCompare) {
        LoadCompareTrendReports(FilterComponentData);
      } else {
        LoadTrendReport(FilterComponentData);
      }
    } else {
      setIsLoading(false);
      setTrendsOverTimeReportData([]);
      setSubTitle('');
    }

    return () => {
      isCancelled = true;
    };
  }, [FilterComponentData, history]);

  function getDetailsPageUrl() {
    return '/shipments?' + baseQueryString;
  }

  return (
    <>
      {FilterComponentData && FilterComponentData.comparePeriodFilter && FilterComponentData.comparePeriodFilter.enabledCompare ? (
        <ComparePeriodLineChart
          Title="% of Shipment Delays"
          ChartId="ComparePercentOfShipmentDelayChart"
          TrendsOverTimeReportDatas={mainAndCompareTrendData}
          GroupBy={FilterComponentData.groupBy}
          HiddenAllSuppliersSeriesOnInit={FilterComponentData.showSuppliersIndividually}
          IsLoading={isLoading}
          TitleLinkUrl={getDetailsPageUrl()}
          TooltipValueFormat="{0}%"
          ValueSuffix="%"
          SubTitle={compareChartSubTitle}
          InverseGainAndLoseStatus={true}
        ></ComparePeriodLineChart>
      ) : (
        <XYChartTrends
          Title="% of Shipment Delays"
          ChartId="PercentOfShipmentDelayChart"
          TrendsOverTimeReportData={trendsOverTimeReportData}
          GroupBy={FilterComponentData.groupBy}
          HiddenAllSuppliersSeriesOnInit={FilterComponentData.showSuppliersIndividually}
          IsLoading={isLoading}
          TitleLinkUrl={getDetailsPageUrl()}
          TooltipValueFormat="{0}%"
          ValueSuffix="%"
          SubTitle={subTitle}
          ShowTrendLine={ShowTrendLine}
          ShowAvgLine={ShowAvgLine}
        ></XYChartTrends>
      )}
    </>
  );
}

export default PercentOfShipmentDelay;
